// WARNING: these values are also used as storage key
export enum BoosterType {
    JOKER = 'boosterJoker',
    UNDO = 'boosterUndo',
    TNT = 'boosterTNT',
    SHUFFLE = 'boosterShuffle',
    BULLS_EYE = 'boosterBullseye',
    PLUS_FIVE = 'boosterPlusFive',
    PLUS_THREE = 'boosterPlusThree',
    PLUS_ONE = 'boosterPlusOne',
}

export enum PreBoosterType {
    REMOVE_THREE = 'preBoosterRemoveThree',
    JOKER = 'preBoosterJoker',
    CANISTER = 'preBoosterCanister',
}

export type AnyBoosterType = BoosterType | PreBoosterType;

export const isPreBoosterType = (type: AnyBoosterType): type is PreBoosterType => {
    return Object.values(PreBoosterType).includes(type as PreBoosterType);
};

export function createBoostersRecord<T>(mapFunc: (boosterType: BoosterType) => T): Record<BoosterType, T> {
    return {
        [BoosterType.JOKER]: mapFunc(BoosterType.JOKER),
        [BoosterType.UNDO]: mapFunc(BoosterType.UNDO),
        [BoosterType.TNT]: mapFunc(BoosterType.TNT),
        [BoosterType.SHUFFLE]: mapFunc(BoosterType.SHUFFLE),
        [BoosterType.BULLS_EYE]: mapFunc(BoosterType.BULLS_EYE),
        [BoosterType.PLUS_FIVE]: mapFunc(BoosterType.PLUS_FIVE),
        [BoosterType.PLUS_THREE]: mapFunc(BoosterType.PLUS_THREE),
        [BoosterType.PLUS_ONE]: mapFunc(BoosterType.PLUS_ONE),
    };
}

export function createPreBoostersRecord<T>(mapFunc: (preBoosterType: PreBoosterType) => T): Record<PreBoosterType, T> {
    return {
        [PreBoosterType.REMOVE_THREE]: mapFunc(PreBoosterType.REMOVE_THREE),
        [PreBoosterType.JOKER]: mapFunc(PreBoosterType.JOKER),
        [PreBoosterType.CANISTER]: mapFunc(PreBoosterType.CANISTER),
    };
}

export function createAnyBoostersRecord<T>(mapFunc: (anyBoosterType: AnyBoosterType) => T): Record<AnyBoosterType, T> {
    return {
        ...createBoostersRecord(mapFunc),
        ...createPreBoostersRecord(mapFunc),
    };
}
